import React from 'react';
import { IconContainer } from './IconContainer';

const PackagesIcon = (props) => {
    return (
        <IconContainer ariaLabel="packages" {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM4 7V19H20V7H4Z"></path>
            </svg>
        </IconContainer>
    )
}

export { PackagesIcon };